//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        reload: {
            type: [Function, Boolean],
            default: false
        }
    },
    data () {
        return {

        }
    },
    methods: {

    },
    mounted: function() {

    }
}
